module.exports = __webpack_public_path__ + "static/img/imgs.e3324c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/imgs.png
// module id = t/sM
// module chunks = 22